export default "__VITE_ASSET__CxTgTCLL__"